import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=e54000b0&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Switcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports